import ReactDOM from "react-dom/client";
// Load the Poppins weights referenced by the MUI theme. Without these imports
// the theme's `fontFamily: "Poppins"` silently falls back to the system font.
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "./index.css";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <App />,
);
